import { InsertClinicalDocs as UseCaseReduxInsertClinicalDocs } from '~/domain/usecases/clinicalDocs/redux';
import { ReduxInsertClinicalDocs } from '~/data/store/reducer/clinicalDocs/usecases/ReduxInsertClinicalDocs';

/**
 * send request via REDUX.
 */
export const makeReduxInsertClinicalDocs = (): UseCaseReduxInsertClinicalDocs =>
  new ReduxInsertClinicalDocs();
